import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

export default function CopyButton({ text, label = "Copy", testId }) {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    const fallback = () => {
      const ta = document.createElement("textarea");
      ta.value = text || "";
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { document.execCommand("copy"); } catch {}
      document.body.removeChild(ta);
    };
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text || "");
      } else {
        fallback();
      }
    } catch {
      fallback();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };
  return (
    <button
      type="button"
      onClick={onCopy}
      data-testid={testId}
      className="font-mono-plex"
      style={{
        display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12,
        textTransform: "uppercase", letterSpacing: "0.08em",
        border: "1px solid var(--line)", background: copied ? "#FFDF57" : "#fff",
        color: "#0F1317", padding: "6px 12px", borderRadius: 8, cursor: "pointer",
        transition: "background-color 0.18s ease",
      }}
    >
      {copied ? <Check size={14} /> : <Copy size={14} />}
      {copied ? "Copied" : label}
    </button>
  );
}
